/**
* Author: DanSmile
* Date: 2019/8/7
* Time: 18:53
*/
<template>
    <div class="box">
        <yd-popup v-model="showPopup" position="bottom" height="50%">
            <v-distpicker type="mobile" @selected="onSelected"></v-distpicker>
        </yd-popup>
        <yd-popup v-model="showPopupTicket" position="bottom" height="50%">
            <v-distpicker type="mobile" @selected="onSelectedTicket" hide-area></v-distpicker>
        </yd-popup>
        <div class="sign-fail" v-if="errorMsg">
            <Icon type="ios-close-circle" size="60" color="#FA6A6A" class="icon"/>
            <p class="mesg">{{errorMsg}}</p>
            <Button type="primary" shape="circle" to="/">去首页</Button>
        </div>

        <swiper v-else :options="swiperOptionOut" ref="swiperOut">
            <swiper-slide>
                <div class="login">
                    <p class="title">{{info.train_name}}</p>
                    <p class="msg">{{info.begin_time + ' 至 '+ info.end_time}}</p>
                    <Input v-model="name" placeholder="请输入姓名" />
                    <Input type="number" v-model="mobile" placeholder="请输入手机号" />
                    <Button type="primary" shape="circle" long  @click="check">下一步</Button>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="code-box" v-if="formItem.name === ''">
                    <p class="title">请输入验证码</p>
                    <div class="ys-verification" v-if="send">
                        <div class="input-wrapper" v-for="item in amount" :key="item">
                            <input type="number"  @paste="handlePaste" title="code" v-focus="(item - 1) === currentIndex" maxlength="1" max="1" @input="handleInput($event,(item-1))" @keyup.delete="onDelete($event,(item-1))"  v-model="code[item-1]">
                        </div>
                    </div>
                    <Button  shape="circle" long v-if="code.join('').length !== 4 && codeTime !== 0"  disabled style="background-color: rgb(247,247,247)">验证码已发送请注意查收 {{codeTime}}S</Button>
                    <Button type="primary" shape="circle" long v-if="code.join('').length !== 4 && codeTime === 0" @click="sendAgain">重新发送验证码</Button>
                    <Button type="primary" shape="circle" long v-if="code.join('').length === 4" @click="checkCode">确认</Button>
                </div>
            </swiper-slide>


            <swiper-slide>
<!--                <div class="progress">-->
<!--                    <div class="layout">-->
<!--                        <span class="subtitle">完整度</span>-->
<!--                        <Progress :percent="finished" :stroke-width="6" stroke-color="#29A77F"/>-->
<!--                    </div>-->
<!--                </div>-->
                <yd-cell-group :model="formItem">
                    <yd-cell-item>
                        <span slot="left">姓名：</span>
                        <yd-input slot="right" v-model="formItem.name" max="20" readonly disabled :show-success-icon="false" :show-error-icon="false" placeholder="请输入姓名"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">性别：</span>
                        <yd-radio-group  slot="right" v-if="formItem.name" v-model="formItem.sex" color="#359265">
                            <yd-radio :val="1" disabled>男</yd-radio>
                            <yd-radio :val="0" disabled>女</yd-radio>
                        </yd-radio-group>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">联系方式：</span>
                        <yd-input slot="right" v-model="formItem.mobile" readonly disabled regex="mobile" :show-success-icon="false" :show-error-icon="false" placeholder="请输入手机号码"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">出生日期：</span>
                        <yd-datetime type="date" v-model="formItem.birth" slot="right" start-date="1985-01-01" :end-date="nowDate"></yd-datetime>
                    </yd-cell-item>
                    <yd-cell-item @click.native="showPopup = true">
                        <span slot="left">籍贯：</span>
                        <span slot="left">{{formItem.nativeplace || '请选择'}}</span>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">邮寄地址：</span>
                        <yd-input slot="right"  v-model="formItem.post_place" :show-success-icon="false" :show-error-icon="false" placeholder="方便邮寄培训物资"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">身份证号：</span>
                        <yd-input slot="right" v-model="formItem.id_number" :show-success-icon="false" :show-error-icon="false" max="20" placeholder="仅报销车票使用"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">邮箱：</span>
                        <yd-input slot="right" v-model="formItem.email" :debug="true" regex="email" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-accordion accordion>
                        <yd-accordion-item title="第一意向城市：">
                            <div style="padding: .24rem;">
                                <yd-radio-group v-if="formItem.name" v-model="formItem.city_1" color="#359265">
                                    <yd-radio v-for="(city, i) in tags.citys" :key="i" :val="city.label">{{city.label}}</yd-radio>
                                </yd-radio-group>
                            </div>
                        </yd-accordion-item>
                    </yd-accordion>
                    <yd-cell-item>
                        <span slot="left">第一意向城市原因：</span>
                        <yd-input slot="right" v-model="formItem.city_1_reason" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-accordion accordion>
                        <yd-accordion-item title="第二意向城市：">
                            <div style="padding: .24rem;">
                                <yd-radio-group v-if="formItem.name" v-model="formItem.city_2" color="#359265">
                                    <yd-radio v-for="(city, i) in tags.citys" :key="i" :val="city.label">{{city.label}}</yd-radio>
                                </yd-radio-group>
                            </div>
                        </yd-accordion-item>
                    </yd-accordion>
                    <yd-cell-item>
                        <span slot="left">第二意向城市原因：</span>
                        <yd-input slot="right" v-model="formItem.city_2_reason" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">是否同意服从分配：</span>
                        <yd-radio-group  slot="right" v-if="formItem.name" v-model="formItem.agree_to_adjust" color="#359265">
                            <yd-radio :val="1">同意</yd-radio>
                            <yd-radio :val="0">不同意</yd-radio>
                        </yd-radio-group>
                    </yd-cell-item>
                    <yd-accordion accordion>
                        <yd-accordion-item title="政治面貌：">
                            <div style="padding: .24rem;">
                                <yd-radio-group v-if="formItem.name" v-model="formItem.politics_status" color="#359265">
                                    <yd-radio v-for="(politics, i) in tags.politics_status" :key="i" :val="politics">{{politics}}</yd-radio>
                                </yd-radio-group>
                            </div>
                        </yd-accordion-item>
                    </yd-accordion>


                    <yd-cell-item>
                        <span slot="left">紧急联系人：</span>
                        <yd-input slot="right" v-model="formItem.emergency_contact.name" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>

                    <yd-accordion accordion>
                        <yd-accordion-item title="紧急联系人关系：">
                            <div style="padding: .24rem;">
                                <yd-radio-group v-if="formItem.name" v-model="formItem.emergency_contact.relation" color="#359265">
                                    <yd-radio shape="circle" v-for="(item, i) in tags.relations" :key="i" :val="item">{{item}}</yd-radio>
                                </yd-radio-group>
                            </div>
                        </yd-accordion-item>
                    </yd-accordion>
                    <yd-cell-item>
                        <span slot="left">紧急联系人电话：</span>
                        <yd-input slot="right" v-model="formItem.emergency_contact.phone" regex="mobile" :show-success-icon="false" :show-error-icon="false" placeholder="请输入手机号码"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">实习日期：</span>
                        <yd-datetime type="date" v-model="formItem.work_date" slot="right" :start-date="nowDate"></yd-datetime>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">家庭住址：</span>
                        <yd-input slot="right" v-model="formItem.family_place" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">学校所在地：</span>
                        <yd-input slot="right" v-model="formItem.school_place" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">本科院校：</span>
                        <yd-input slot="right" v-model="formItem.education_info.university" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">本科专业：</span>
                        <yd-input slot="right" v-model="formItem.education_info.major" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">研究生院校：</span>
                        <yd-input slot="right" v-model="formItem.education_info.graduate" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="没有研究生院校可填无"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">研究生专业：</span>
                        <yd-input slot="right" v-model="formItem.education_info.graduate_major" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                    </yd-cell-item>
                    <yd-cell-item>
                        <span slot="left">应届或往届：</span>
                        <yd-radio-group  slot="right" v-if="formItem.name" v-model="formItem.graduating" color="#359265">
                            <yd-radio :val="1">应届</yd-radio>
                            <yd-radio :val="0">往届</yd-radio>
                        </yd-radio-group>
                    </yd-cell-item>
                    <div v-if="!info.type">
                        <yd-cell-item>
                            <span slot="left">银行卡号：</span>
                            <yd-input slot="right" v-model="formItem.bank_info.bank_card" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                        </yd-cell-item>
                        <yd-cell-item>
                            <span slot="left">银行开户行名称：</span>
                            <yd-input slot="right" v-model="formItem.bank_info.bank_branch" max="20" :show-success-icon="false" :show-error-icon="false" placeholder="请输入"></yd-input>
                        </yd-cell-item>
                        <yd-cell-item @click.native="showPopupTicket = true">
                            <span slot="left">交通票出发城市：</span>
                            <span slot="left">{{formItem.ticket_city || '请选择'}}</span>
                        </yd-cell-item>
                    </div>
                    <yd-accordion accordion>
                        <yd-accordion-item title="意向科目：">
                            <div style="padding: .24rem;">
                                <yd-radio-group v-if="formItem.name" v-model="formItem.purpose_sub" color="#359265">
                                    <yd-radio v-for="(sub, i) in tags.subs" :key="i" :val="sub.label">{{sub.label}}</yd-radio>
                                </yd-radio-group>
                            </div>
                        </yd-accordion-item>
                    </yd-accordion>
                    <div>
                        <Upload type="drag" :before-upload="uploadPic" :format="['jpg','jpeg','png']" action="#" class="upload-pic">
                            <div style="width: 100px;height: 130px;" v-show="formItem.head_src === ''">
                                <img src="@/m/images/head.png" width="100%"/>
                            </div>
                            <img :src="formItem.head_src" v-show="formItem.head_src !== ''"  width="100%"/>
                        </Upload>
                        <p class="zcon">证件照或生活照</p>
                    </div>


                    <div class="sub-box">
                        <p class="notice">注意事项：1.如果你已填写过一次报名链接，但由于自身原因放弃参培，那么如果第二次填写后再次放弃，无论什么原因，都将被拉入黑名单，不得参培！</p>
                        <yd-checkbox v-model="agree1"  shape="circle" color="#359265">我已知晓</yd-checkbox>
                        <p class="notice" v-if="info.type">注意事项：2.由于疫情影响，本期培训全程采用线上模式，需要的设备为电脑，平板或者手机均可，但是必须保证网络良好，培训期间尽量使用wifi或者4G网络。</p>
                        <p class="notice" v-else>注意事项：2.应届生来程报销标准必须为学校——培训地的交通费，返程可以为培训地——学校或家的交通费；往届生来返程报销标准必须为家——培训地的交通费。其余情况不予报销。报销最高标准为高铁二等座票价。</p>
                        <yd-checkbox v-model="agree2"  shape="circle" color="#359265">我已知晓</yd-checkbox>
                        <p class="notice" v-if="info.type">注意事项：3.线上培训采用软件为classin,注册的账号必须为报名链接中所填写的电话号码，密码自行设置即可。</p>
                        <p class="notice" v-else>注意事项：3.来程车票的日期为培训开始前3天之内，返程车票的日期为培训结束后3天之内，中间换乘不得超过24小时。返程票最好不要提前购买，如果培训期间退出或淘汰，因个人原因提前购票，所产生的改签费等概不报销。</p>
                        <yd-checkbox v-model="agree3"  shape="circle" color="#359265">我已知晓</yd-checkbox>
                        <p class="notice">本人声明：以上提供的内容完全属实，如本声明及其他部分系伪造或不正确，本人同意并接受平行线可随时终止同我签订的协议与劳动合同</p>
                        <yd-checkbox v-model="agree4"  shape="circle" color="#359265">我已知晓</yd-checkbox>

                    </div>
                    <yd-button size="large" type="primary" shape="circle" bgcolor="#369567" color="#fff" class="sbtn" @click.native="handleSubmit" v-points>提交</yd-button>

                </yd-cell-group>
            </swiper-slide>


            <swiper-slide>
                <div class="success">
                    <Icon type="ios-checkmark-circle" size="60" color="#29A77F" class="icon"/>
                    <p class="mesg">报名成功</p>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import VDistpicker from 'v-distpicker'
    import VuePicker from 'vue-pickers'
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    export default {
        name: 'train_index',
        components: {
            swiper,
            swiperSlide,
            VuePicker,
            VDistpicker
        },
        data () {
            return {
                showPopup: false,
                showPopupTicket: false,
                showPicker: false,
                nowDate: '',
                tags: {
                    citys: [],
                    politics_status: [],
                    subs: [],
                    realations: []
                },
                agree1: false,
                agree2: false,
                agree3: false,
                agree4: false,
                name: '',
                mobile: '',
                formItem:{
                    name: '',
                    sex:1,
                    mobile:'',
                    birth: '1998-01-01',
                    nativeplace:'',
                    post_place: '',
                    id_number: '',
                    email:'',
                    city_1: '',
                    city_1_reason: '',
                    city_2: '',
                    city_2_reason: '',
                    agree_to_adjust: 1,
                    politics_status: '',
                    emergency_contact: {
                        name: '',
                        relation: '',
                        phone: ''
                    },
                    work_date: '',
                    family_place: '',
                    school_place: '',
                    education_info: {
                        university: '',
                        major: '',
                        graduate:'',
                        graduate_major:''
                    },
                    graduating: '',
                    bank_info: {
                        bank_card: '',
                        bank_branch: ''
                    },
                    ticket_city: '',
                    purpose_sub: '',
                    head_src: ''
                },
                codeTime: 60,
                amount: 4,
                errorMsg: false,
                send: false,
                info: {
                    begin_time: '',
                    end_time: '',
                    period: '',
                    train_name: '',
                    type: 1
                },
                code: [],
                currentIndex: 0,
                swiperOptionOut: {
                    allowTouchMove: false
                },
            }
        },
        directives: {
            focus: {
                componentUpdated: function (el, obj) {
                    obj.value && el.focus()
                }
            }
        },
        methods: {
            onSelected(data){
                this.formItem.nativeplace = data.province.value + '-' + data.city.value + '-' + data.area.value
                this.showPopup = false
            },
            onSelectedTicket(data){
                this.formItem.ticket_city = data.province.value + '-' + data.city.value
                this.showPopupTicket = false
            },
            setShowPicker(name){
                this.showPicker = name
            },
            pickerCancel () {
                this.showPicker = false
            },
            pickerConfirm (res, name) {
                this.formItem[name] = res[0].label
                this.showPicker = false
            },
            uploadPic (file) {
                console.log(file);
                const allowType = ['image/jpg','image/jpeg','image/png'];
                if (file.size > 2 * 1024 * 1024){
                    this.$Message.warning('图片不能超过2M哦~');
                    return false
                }
                if (allowType.indexOf(file.type) === -1){
                    this.$Message.warning('图片类型错误哦~');
                    return false
                }
                var formData = new window.FormData();
                formData.append('image', file);
                console.log(formData);
                this.$axios.post(this.api.uploadHeadPic, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then( res => {
                    this.formItem.head_src = res.data.url;
                    console.log(res);
                });
                return false
            },
            getData() {
                this.$axios.get(this.api.getTrainInfo + '/' + this.$route.params.period).then(res=>{
                    if(res.code){
                        this.info = res.data
                    }else {
                        this.errorMsg = res.msg
                    }
                })
            },
            handleInput (e, index) {
                this.currentIndex = index
                e.target.value = this.validateNumber(e.target.value)
                e.target.value !== '' && ++this.currentIndex
                const code = this.code
                if(code.join('').split('').length >= 4){
                    this.code = code.join('').split('').slice(0,4)
                    this.currentIndex = 3
                }else{
                    this.code = code

                }
            },
            onDelete (e, index) {
                if (e.target.value === '') {
                    this.currentIndex = index - 1
                }
            },
            validateNumber (val) {
                return val.replace(/\D/g, '')
            },
            handlePaste (e) {
                e.preventDefault()
            },
            check() {
                this.$axios.post(this.api.trainCheck,{
                    name: this.name,
                    mobile: this.mobile,
                    period: this.$route.params.period,
                }).then( res =>{
                    if( res.code === 1 ){
                        this.$Message.success(res.msg)
                        this.$refs.swiperOut.swiper.slideNext()
                        document.body.scrollIntoView()
                        this.send = true
                        let v =  setInterval(()=>{
                            if(this.codeTime === 0) return clearInterval(v)
                            this.codeTime --
                        }, 1000)
                    }else if(res.code === -2){
                        this.errorMsg = res.msg
                    }else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            sendAgain() {
                this.$axios.post(this.api.evalCheck,{
                    evaluation_id: this.$route.params.id,
                    mobile: this.mobile,
                }).then( res =>{
                    if( res.code === 1 ){
                        this.$Message.success(res.msg)
                        this.send = true
                        this.code = new Array(this.amount).fill('')
                        this.currentIndex = 0
                        let v =  setInterval(()=>{
                            if(this.codeTime === 0) return clearInterval(v)
                            this.codeTime --
                        }, 1000)
                    }else if(res.code === -2){
                        this.errorMsg = res.msg
                    }else {
                        this.$Message.warning(res.msg)
                    }
                })
            },
            checkCode(){
                this.$axios.post(this.api.trainCheckCode,{
                    period: this.$route.params.period,
                    name: this.name,
                    mobile: this.mobile,
                    code: this.code.join('')
                }).then(res=>{
                    // console.log('checkcode',res)
                    if( res.code === -2) {
                        this.errorMsg = res.msg
                    }else if( res.code === 0){
                        this.$Message.error(res.msg)
                    }else if( res.code === -3){
                        this.$Message.error(res.msg)
                        this.code = new Array(this.amount).fill('')
                    }else{
                        this.formItem = res.data.info
                        this.tags = res.data.tags
                        this.$refs.swiperOut.swiper.slideNext()
                        document.body.scrollIntoView()

                    }
                })
            },
            handleSubmit() {
                if(!this.agree1 || !this.agree2 || !this.agree3) return this.$Message.error('请确认注意事项')
                if(!this.agree4) return this.$Message.error('请确认本人声明')
                this.$axios.post(this.api.trainSub,{
                    period: this.$route.params.period,
                    mobile: this.mobile,
                    name: this.name,
                    info: this.formItem
                }).then(res=>{
                    if( res.code === -2) {
                        this.errorMsg = res.msg
                    }else if( res.code === 0){
                        this.$Message.error(res.msg)
                    }else{
                        this.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',

                            callback: () => {
                                this.$refs.swiperOut.swiper.slideNext()
                                document.body.scrollIntoView()

                                // this.$router.push('/');
                            }
                        });
                    }
                })
            }
        },
        computed: {
            // finished () {
            //     const finish = Object.keys(this.formItem).filter(key => {
            //         if (this.formItem[key] !== '') return 1
            //     }).length
            //     if(!this.info.type){
            //         return (finish/24).toFixed(2)*100
            //     }else {
            //         return (finish/23).toFixed(2)*100
            //     }
            // },
            formatSeconds () {
                let secondTime = parseInt(this.second);// 秒
                let minuteTime = 0;// 分
                let hourTime = 0;// 小时
                if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
                    //获取分钟，除以60取整数，得到整数分钟
                    minuteTime = parseInt(secondTime / 60);
                    //获取秒数，秒数取佘，得到整数秒数
                    secondTime = parseInt(secondTime % 60);
                    //如果分钟大于60，将分钟转换成小时
                    if (minuteTime > 60) {
                        //获取小时，获取分钟除以60，得到整数小时
                        hourTime = parseInt(minuteTime / 60);
                        //获取小时后取佘的分，获取分钟除以60取佘的分
                        minuteTime = parseInt(minuteTime % 60);
                    }
                }
                let result = parseInt(secondTime) > 9 ? '' + parseInt(secondTime) : '0' + parseInt(secondTime);

                if (minuteTime > 0) {
                    result = (parseInt(minuteTime) > 9 ? '' + parseInt(minuteTime) : '0' + parseInt(minuteTime)) + ":" + result;
                }
                if (hourTime > 0) {
                    result = (parseInt(hourTime) > 9 ? '' + parseInt(hourTime) : '0' + parseInt(hourTime)) + ":" + result;
                }
                return result;
            }
        },

        created () {
            this.code = new Array(this.amount).fill('')
            this.getData()
            const date = new Date
            const month = date.getMonth() + 1
            this.nowDate = date.getFullYear() + '-' + (month < 10 ? '0'+ month : month) + '-' + date.getDate()
        },
    }
</script>

<style lang="less" scoped>
    .box{
        min-height: 100vh;
        .login{
            padding: 10px 50px;
            background: url(../../images/trainbg.png) 0 0 no-repeat;
            background-size: contain;
            .title{
                text-align: center;
                font-size: 22px;
                color: #000000;
                font-weight: bold;
                padding: 60px 0 10px 0;
                word-break: break-word;
            }
            .msg{
                color: #111;
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 50px;
            }
            .ivu-btn{
                background-color: #29A77F;
                padding: 10px 0;
                margin-top: 15px;
            }
            /deep/.ivu-input{
                height: 40px;
                padding: 8px 15px;
                background-color: #F7F7F7;
                border: none;
                border-radius: 25px;
                margin: 10px 0;

            }
        }
        .progress{
            padding: 2px 30px 20px 30px;
            .layout{
                padding: 2px 0;
                display: flex;
                justify-content: space-between;
            }
            .subtitle{
                width: 60px;
            }
            .num{
                color: #BFC1C6;
                margin-left: 10px;
                span{
                    color: #29A77F;
                }
            }
        }
        .code-box{
            padding: 10px 50px;
            .title{
                font-size: 26px;
                color: #000000;
                font-weight: bold;
                padding: 30px 0;
            }
            .ivu-btn{
                background-color: #29A77F;
                padding: 10px 0;
                margin-top: 15px;
            }
            .ys-verification{
                margin: 30px 0 20px 0;
                display: flex;
                justify-content: space-around;
                .input-wrapper{
                    width: 20%;
                    height: 0;
                    padding-bottom: 20%;
                    input{
                        width: 60px;
                        height: 60px;
                        text-align: center;
                        transition: all 0.3s;
                        font-size: 7vw;
                        color: #262626;
                        border: 1px solid #E6E8ED;
                        border-radius: 10px;
                    }
                }
                input:focus{
                    border: 1px solid #29A77F;
                }
            }
        }
        .success{
            text-align: center;
            .icon{
                margin: 50px 0 20px 0;
            }
            .mesg{
                color: #1A1A1A;
                font-size: 28px;
                font-weight: bold;
            }
        }
        .upload-pic{
            width: 100px;
            height: 130px;
            margin: 15px auto 10px auto;
            img{
                width: 100px;
                max-height: 130px;
            }
            /deep/.ivu-upload-drag{
                width: 100px;
                height: 130px;
            }

        }
        .zcon{
            text-align: center;
            font-size: 14px;
            color: #989898;
        }
        .sub-box{
            .notice{
                color: #666;
                font-size: 14px;
                margin: 10px .24rem;
            }
            .yd-checkbox-circle{
                margin: 0 0 5px .24rem;
            }
        }
        .sbtn{
            width: 90%;
            margin: 20px 5% 0 5%;
            box-shadow: 0px 10px 10px -10px  rgba(53, 147, 102, .8);
        }
        .sign-fail{
            text-align: center;
            .icon{
                margin: 50px 0 20px 0;
            }
            .mesg{
                color: #1A1A1A;
                font-size: 28px;
                font-weight: bold;
            }
            .num{
                color: #BABDC3;
                line-height: 30px;
                font-size: 14px;
            }
            .ivu-btn{
                background-color: #29A77F;
                padding: 10px 50px;
                margin-top: 30px;
            }
        }
    }
    /deep/.yd-cell:after{
        background-image: none;
    }
</style>
